export const moveToLastStep = (currentStep, lastStep, setCurrentStep, setPreveStep) => {
  if (currentStep === lastStep) return;
  setPreveStep(() => lastStep);
  setCurrentStep(() => lastStep);
};
